var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productDiv"},[_c('b-container',[_c('ProductNav',{on:{"changeMenu":_vm.changeMenu,"changeTab":_vm.changeTab}}),_c('Detail',{attrs:{"productId":_vm.productId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }